// extracted by mini-css-extract-plugin
export default {"wrapper":"Spaces_wrapper__h9B9N","spaceList":"Spaces_spaceList__V5Xo1","spaceNavWrapper":"Spaces_spaceNavWrapper__CJb4G","spaceMapView":"Spaces_spaceMapView__MV7S8"};